import { render, staticRenderFns } from "./SegmentedTrendsEventTable.vue?vue&type=template&id=fe4e7b94&scoped=true"
import script from "./SegmentedTrendsEventTable.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsEventTable.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsEventTable.vue?vue&type=style&index=0&id=fe4e7b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4e7b94",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-event-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsEventTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports